<script setup lang="ts">
import { ModalDefault } from '@shared/ui/modals'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalTutorBillingView } from '../../model/modal-tutor-billing-view.hook'
import TutorBillingModalHeader from '../TutorBillingModalHeader.vue'
import TutorBillingFieldsTable from '../TutorBillingFieldsTable.vue'

defineOptions({
  name: 'ModalTutorBillingView',
})

const {
  isOpen,
  title,
  subtitle,
  columns,
  rows,
  setClose,
  setOpenEdit,
} = useModalTutorBillingView()
</script>

<template>
  <ModalDefault
    :show="isOpen"
    class-name="modal-tutor-billing-view"
    is-close-button
    @click:overlay="setClose"
    @click:close="setClose"
  >
    <TutorBillingModalHeader
      :title="title"
      :subtitle="subtitle"
    />
    <TutorBillingFieldsTable
      :columns="columns"
      :rows="rows"
    />
    <template #controls>
      <BtnPrimary
        text="Edit billing info"
        @click="setOpenEdit"
      />
      <BtnSecondary
        text="Close"
        @click="setClose"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalTutorBillingView.scss" />
